<div class="app-container" [class.is-mobile]="mobileQuery.matches">
    <mat-toolbar [class.mat-elevation-z6]="true">
      <button mat-icon-button *ngIf="createFirstOuting == false" (click)="toggled = !toggled">
        <mat-icon class="icon-100-hue">menu</mat-icon>
      </button>
      <span class="hoverable" [routerLink]="['/outing-management/dashboard']" routerLinkActive="router-link-active">
        <img src="../assets/img/golftech-v2-whiteoutline.png" alt="Golf Tech Logo" height="70" />
      </span>
      <mat-chip-set *ngIf="selectedOuting && selectedIteration">
        <mat-chip highlighted="true" chipListSelectable="false">{{selectedOuting?.name}} - {{selectedIteration?.startDate | date:'MM/dd/yyyy'}}</mat-chip>
      </mat-chip-set>
      <span class="spacer"></span>
      <button mat-icon-button [matMenuTriggerFor]="accountMenu">
        <mat-icon class="icon-100-hue">account_circle</mat-icon>
      </button>
      <span>{{user?.firstName}} {{user?.lastName}}</span>
      <mat-menu #accountMenu="matMenu">
        <p class="gt-display-type">{{golfTechTypeDisplayName(user?.golfTechType)}}</p>
        <hr />
        <button *ngIf="user?.golfTechType === 5" mat-menu-item [routerLink]="['/simulator-management']">Simulators</button>
        <button mat-menu-item [routerLink]="['/outing-management/my-account', user.id]">My Account</button>
        <button mat-menu-item (click)="logout()">Log Out</button>
        <mat-slide-toggle (change)="onToggleChange($event)" [checked]="isDarkTheme">Dark Theme</mat-slide-toggle>
      </mat-menu>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <div *ngIf="isSkeletonLoading">
      <post-login-layout-skeleton></post-login-layout-skeleton>
    </div>
    <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0"
      *ngIf="createFirstOuting == false">
      <mat-sidenav *ngIf="sessionService.isUserLoggedIn() && isOutingSelected" #sidenav
        [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="toggled"
        [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" style="width: 250px" [class.mat-elevation-z2]="true">
        <mat-nav-list>
          <div *ngIf="user?.golfTechType === 5 || user?.golfTechType === 1">
            <h2 mat-subheader>
              <mat-icon matListIcon>supervised_user_circle</mat-icon>&nbsp;Administration
            </h2>
            <mat-expansion-panel [class.mat-elevation-z0]="true">
              <mat-expansion-panel-header>
                Registration
              </mat-expansion-panel-header>
              <mat-nav-list dense>
                <a mat-list-item [routerLink]="['/outing-management/administration/registrations']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Registrations</a>
                <a mat-list-item [routerLink]="['/outing-management/administration/registration/create']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Create Registration(s)</a>
                <a mat-list-item [routerLink]="['/outing-management/administration/registrations/teams']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Teams</a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel [class.mat-elevation-z0]="true">
              <mat-expansion-panel-header>
                Outing
              </mat-expansion-panel-header>
              <mat-nav-list dense>
                <a mat-list-item [routerLink]="['/outing-management/administration/outings']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">View Outings</a>
                <a mat-list-item [routerLink]="['/outing-management/administration/outing/create']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Create Outing</a>
                <a mat-list-item [routerLink]="['/outing-management/administration/outing/iterations']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Iterations</a>
                <!-- <a mat-list-item [routerLink]="['/outing-management/administration/outing/permissions/create']"
                  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Permissions</a> -->
                <a mat-list-item [routerLink]="['/outing-management/administration/prizes']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Prizes</a>
                <a mat-list-item [routerLink]="['/outing-management/administration/sponsors']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Sponsors</a>
              </mat-nav-list>
            </mat-expansion-panel>
            <hr />
            <mat-nav-list>
              <h2 mat-subheader><mat-icon matListIcon>widgets</mat-icon>&nbsp;Widgets</h2>
                <mat-nav-list dense>
                  <a mat-list-item [routerLink]="['/outing-management/widget-shells/registrations-widget-shell']" routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{exact: true}">Registration</a>
                </mat-nav-list>
            </mat-nav-list>
          </div>
        </mat-nav-list>
        <hr />
        <mat-nav-list>
          <h2 mat-subheader>
            <mat-icon matListIcon>campaign</mat-icon>&nbsp;Notification
          </h2>
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              Campaigns
            </mat-expansion-panel-header>
            <mat-nav-list dense>
              <a mat-list-item [routerLink]="['notification/campaigns']" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{exact: true}">View</a>
              <a mat-list-item [routerLink]="['notification/campaign/create/:id']" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{exact: true}">Create</a>
            </mat-nav-list>
          </mat-expansion-panel>
        </mat-nav-list>
        <hr />
        <mat-nav-list>
          <h2 mat-subheader>
            <mat-icon matListIcon>support_agent</mat-icon>&nbsp;Support
          </h2>
          <mat-nav-list dense>
            <a mat-list-item href="https://golftech.atlassian.net/servicedesk/customer/portal/1" target="_blank">Submit a Ticket</a>
          </mat-nav-list>
        </mat-nav-list>
        <ng-container *ngIf="user?.golfTechType === 'GlobalAdmin'">
          <hr />
          <mat-nav-list>
            <h2 mat-subheader>
              <mat-icon matListIcon>settings</mat-icon>&nbsp;GolfTech Settings
            </h2>
            <mat-expansion-panel [class.mat-elevation-z0]="true">
              <mat-expansion-panel-header>
                Administration
              </mat-expansion-panel-header>
              <mat-nav-list dense>
                <a mat-list-item [routerLink]="['gt-administration/create/account']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Create Account</a>
                <a mat-list-item [routerLink]="['gt-administration/users']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Users</a>
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel [class.mat-elevation-z0]="true">
              <mat-expansion-panel-header>
                Course
              </mat-expansion-panel-header>
              <mat-nav-list dense>
                <a mat-list-item [routerLink]="['administration/courses']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">View Courses</a>
                <a mat-list-item [routerLink]="['administration/course/create']" routerLinkActive="active-link"
                  [routerLinkActiveOptions]="{exact: true}">Add Course</a>
              </mat-nav-list>
            </mat-expansion-panel>
          </mat-nav-list>
        </ng-container>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="component-viewer" *ngIf="!isSkeletonLoading">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <div class="component-viewer" *ngIf="isOutingSelected == false && createFirstOuting == true && !isSkeletonLoading">
      <outing-create isFirstOuting="true" (outingCreationEvent)="onFirstOutingCreation($event)"
        isLoading="isLoading"></outing-create>
    </div>
  </div>